
import React, { ReactNode } from 'react';
import { Separator } from '@/components/ui/separator';

interface PolicyLayoutProps {
  title: string;
  lastUpdated?: string;
  children: ReactNode;
}

export const PolicyLayout = ({ title, lastUpdated, children }: PolicyLayoutProps) => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <div className="bg-card rounded-lg shadow-sm p-6 md:p-8">
        <h1 className="text-3xl font-bold mb-2">{title}</h1>
        {lastUpdated && (
          <p className="text-sm text-muted-foreground mb-4">
            Last updated: {lastUpdated}
          </p>
        )}
        <Separator className="my-4" />
        <div className="prose prose-sm md:prose-base dark:prose-invert max-w-none">
          {children}
        </div>
      </div>
    </div>
  );
};
